import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import MOs from "@/pages/manufacturing/MOs";
import MOCreate from "@/pages/manufacturing/MOCreate";
import MODetail from "@/pages/manufacturing/MODetail";
import BOMs from "@/pages/manufacturing/BOMs";
import BOMForm from "@/pages/manufacturing/BOMForm";
import Lots from "@/pages/manufacturing/Lots";
import LotDetail from "@/pages/LotDetail";
import LotLabel from "@/pages/LotLabel";
import BoxDetail from "@/pages/BoxDetail";
import QRLabels from "@/pages/QRLabels";
import PackingLists from "@/pages/packing/PackingLists";
import PackingListCreate from "@/pages/packing/PackingListCreate";
import PackingListDetail from "@/pages/packing/PackingListDetail";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";

function Protected() {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === undefined) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#002B5D]" data-testid="auth-loading">
        <div className="w-10 h-10 border-4 border-white/30 border-t-white rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname + loc.search }} replace />;
  return <Layout />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route element={<Protected />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/manufacturing" element={<Navigate to="/manufacturing/orders" replace />} />
              <Route path="/manufacturing/orders" element={<MOs />} />
              <Route path="/manufacturing/orders/new" element={<MOCreate />} />
              <Route path="/manufacturing/orders/:id" element={<MODetail />} />
              <Route path="/manufacturing/boms" element={<BOMs />} />
              <Route path="/manufacturing/boms/new" element={<BOMForm />} />
              <Route path="/manufacturing/boms/:id/edit" element={<BOMForm />} />
              <Route path="/manufacturing/lots" element={<Lots />} />
              <Route path="/lots/:id" element={<LotDetail />} />
              <Route path="/lots/:id/label" element={<LotLabel />} />
              <Route path="/lots/:id/labels" element={<QRLabels mode="lot" />} />
              <Route path="/boxes/:id" element={<BoxDetail />} />
              <Route path="/boxes/:id/label" element={<QRLabels mode="box" />} />
              <Route path="/packing-list" element={<PackingLists />} />
              <Route path="/packing-list/new" element={<PackingListCreate />} />
              <Route path="/packing-list/:id" element={<PackingListDetail />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/settings/users" element={<Users />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
